import "./AonPopover.component.scss";
import { UuiPopover } from "@aonunited/react";
import React from "react";
var AonPopover = function (_a) {
    var containerClasses = _a.containerClasses, eventType = _a.eventType, hidearrow = _a.hidearrow, position = _a.position, tooltipContent = _a.tooltipContent, triggerElement = _a.triggerElement, darkMode = _a.darkMode, popoverWidth = _a.popoverWidth, isFullWidth = _a.isFullWidth;
    var popoverClasses = darkMode ? "" : "aon-popover ";
    popoverClasses += popoverWidth ? "".concat(popoverWidth, " ") : "";
    popoverClasses += containerClasses;
    return (React.createElement(React.Fragment, null,
        React.createElement(UuiPopover, { style: isFullWidth ? { display: "flex" } : {}, alwaysontop: true, containerClasses: popoverClasses, eventType: eventType, hidearrow: hidearrow, position: position },
            React.createElement("span", { style: isFullWidth ? { width: "100%", textAlign: "center" } : {}, slot: "trigger" }, triggerElement),
            tooltipContent)));
};
export { AonPopover };
